import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

// Translate fixed application copy at display time. Stored enum values, user
// content, and integration identifiers remain unchanged. Unknown text passes
// through; it must be classified by the localization audit, never guessed.
export const uiText = (text, values = {}) => {
  if (text && typeof text === 'object' && text.uiMessage === true) {
    return uiText(text.key, { ...text.values, ...values });
  }
  if (typeof text !== 'string') return text;
  const key = text.trim().replace(/\s+/g, ' ');
  if (!key) return text;
  const lookup = { ns: 'ui', keySeparator: false, nsSeparator: false };
  if (!i18n.exists(key, lookup)) return text;
  if (!(values.lng || i18n.language || '').startsWith('ar') && !Object.keys(values).length) return text;
  const translated = i18n.t(key, {
    ...values,
    ...lookup,
    defaultValue: key,
  }) ?? key;
  return text.match(/^\s*/)[0] + translated + text.match(/\s*$/)[0];
};

// Components containing source-keyed copy subscribe even when they have no
// other translation hooks, so changing language updates text without a reload.
export const useUiLanguage = () => useTranslation('ui');

export const getUiLocale = () => i18n.resolvedLanguage || i18n.language || 'en';

// Keep async status copy as a template, so a later language change still works.
export const uiMessage = (key, values = {}) => ({ uiMessage: true, key, values });

// Human-readable output only. Never use this for stored dates or identifiers.
export const formatUiDate = (value, options = {}, language = getUiLocale()) => {
  const date = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)
    ? new Date(`${value}T00:00:00`) : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value || '');
  return date.toLocaleDateString(language, { calendar: 'gregory', ...options });
};
